// extracted by mini-css-extract-plugin
module.exports = {"productName":"product-view__productName___2JXII","logo":"product-view__logo___EXqMp","description":"product-view__description___1FW16"};